import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import API from "../../../context/API";
import type { RootState } from "../../../redux/store";
import { THEME_FIELDS } from "../constants";
import type { ThemeColors } from "../types";

export const KIOSK_CONFIG_QUERY_KEY = ["kiosk-configuration"] as const;

export const useKioskConfiguration = () => {
  const { role, loginData } = useSelector((state: RootState) => state.auth);

  return useQuery<ThemeColors>({
    queryKey: KIOSK_CONFIG_QUERY_KEY,
    queryFn: async () => {
      const params: Record<string, string> = {};
      if (role === "admin" || role === "super_admin") {
        params.merchantId = loginData?.merchantId || loginData?.id;
      }
      const res = await API.get("/kiosk-configuration", { params });
      return Object.fromEntries(
        THEME_FIELDS.map((f) => [f.key, res.data[f.key] ?? null])
      ) as ThemeColors;
    },
    staleTime: 5 * 60 * 1000,
  });
};
